import ReportCard from "../../../../../../components/reports/report-card.jsx";

export default function IndividualProfile({ profileData }) {
    return (
        <>
            <div className="grid grid-cols-2">
                <ReportCard
                    title="Total de indivíduos"
                    value={profileData?.total ?? 0}
                />
                <ReportCard
                    title="Indivíduos recorrentes"
                    idTitle="Registrados na mesma condição em períodos anteriores."
                    value={profileData?.reccurrent ?? 0}
                />
            </div>

            <div className="chart-divisor"/>
        </>
    )
}